/*
 * Hides Judge.me review cards/rows whose content was redacted -- typically
 * because the reviewer deleted their Shopify customer account, leaving a
 * blank "(redacted)" review credited to "Deleted user". These still count
 * toward the star average, they just shouldn't be shown.
 *
 * Judge.me renders (and re-renders, e.g. carousel clones, pagination,
 * async widget loads) after this script runs, so a MutationObserver keeps
 * catching new cards rather than a single one-off scan.
 */
(function () {
  function isRedacted(card) {
    var name = card.querySelector('.jdgm-reviewer-name, .jdgm-rev__author');
    var text = card.querySelector('.jdgm-text, .jdgm-rev__body');
    var nameText = name ? name.textContent.trim() : '';
    var bodyText = text ? text.textContent.trim() : '';
    return /^deleted user$/i.test(nameText) || bodyText === '(redacted)';
  }

  function sweep(root) {
    var cards = (root || document).querySelectorAll('.jdgm-card, .jdgm-rev');
    cards.forEach(function (card) {
      if (isRedacted(card)) {
        card.style.display = 'none';
      }
    });
  }

  sweep();

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.jdgm-card, .jdgm-rev')) {
          if (isRedacted(node)) node.style.display = 'none';
        }
        sweep(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
